import classes from './select.module.css'

const Select = {
  classNames: {
    input: classes.input,
    dropdown: classes.dropdown,
    option: classes.option,
  },
}

export default Select
